import { render, staticRenderFns } from "./UomDetails.vue?vue&type=template&id=f58f47a0&scoped=true&"
import script from "./UomDetails.vue?vue&type=script&lang=js&"
export * from "./UomDetails.vue?vue&type=script&lang=js&"
import style0 from "./UomDetails.vue?vue&type=style&index=0&id=f58f47a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f47a0",
  null
  
)

export default component.exports